module.exports = __webpack_public_path__ + "img/logo.9cc257f7.png";